export default {
    namespaced: true,//将getters、mutations、actions路径引入到当前模块命名空间 配置后调用方法 this.$store.commit({type:('user/login')}) 其他方法同 可根据情况不适应此配置
    state:{
        username:'',
        token:'',
        authorities:'',//权限
    },
    getters:{},
    mutations: { 
        loginIn(state,payload){
            state.username=payload.username;
            state.token=payload.token;
        },
        loginOut(state){
            state.username='';
            state.token='';
        },
        authorities(state,authorities){
            state.authorities=authorities;
        }
    },
    actions: { 

    }
}